import React from 'react';
import PropTypes from 'prop-types';
import styled, {keyframes} from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    #e0e0e0 0%,
    #efefef 50%,
    #e0e0e0 100%
  );
  background-size: 1000px 100%;
  animation: ${shimmer} 1.5s infinite linear;
  border-radius: ${props => props.radius || '4px'};
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '20px'};
  margin: ${props => props.margin || '0'};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

const SkeletonCircle = styled(SkeletonBase)`
  border-radius: 50%;
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
`;

const SkeletonImage = styled(SkeletonBase)`
  aspect-ratio: ${props => props.aspectRatio || '1'};
  width: ${props => props.width || '100%'};
  height: auto;
`;

const SkeletonText = styled(SkeletonBase)`
  height: ${props => props.height || '16px'};
  margin-bottom: ${props => props.spacing || '8px'};
`;

export const SkeletonLoader = SkeletonBase;
export const SkeletonCircleLoader = SkeletonCircle;
export const SkeletonImageLoader = SkeletonImage;
export const SkeletonTextLoader = SkeletonText;

const Skeleton = ({type = 'base', ...props}) => {
  switch (type) {
    case 'circle':
      return <SkeletonCircle {...props} />;
    case 'image':
      return <SkeletonImage {...props} />;
    case 'text':
      return <SkeletonText {...props} />;
    default:
      return <SkeletonBase {...props} />;
  }
};

Skeleton.propTypes = {
  type: PropTypes.oneOf(['base', 'circle', 'image', 'text']),
  width: PropTypes.string,
  height: PropTypes.string,
  radius: PropTypes.string,
  margin: PropTypes.string,
  size: PropTypes.string,
  aspectRatio: PropTypes.string,
  spacing: PropTypes.string,
};

export default Skeleton;

